<template>
  <div class="getback login_common">
    <nav-top :navTitle="nav_title"/>

    <div class="section">
      <div class="type_nav flex_center">
        <div class="flex_center" @click="handleIdPasswordTab(1)">
          <div :class="[tabType === 1 ? 'type_nav_button_on' : '' ]" class="type_nav_button">
            아이디 찾기
          </div>
        </div>
        <div class="flex_center" @click="handleIdPasswordTab(2)">
          <div :class="[tabType === 2 ? 'type_nav_button_on' : '' ]" class="type_nav_button">
            비밀번호 찾기
          </div>
        </div>
      </div>

      <!-- 아이디 찾기 -->
      <div v-if="tabType === 1" class="getback_pwd">
        <div class="getback_tip">
          <div>
              회원 가입 시 설정하신 정보로 회원 인증 후<br/>
              아이디를 조회하실 수 있습니다.
              <br/>
              <br/>
              간편 회원가입 회원이실 경우 각 SNS 화면에서<br/>
              아이디 찾기 하실 수 있습니다.
          </div>
        </div>

        <div class="getback_form">
          <el-form ref="formId" :model="formId" :rules="rules" class="form">
            <el-form-item prop="name">
              <el-input v-model="formId.name" type="text" placeholder="이름" :disabled="formId.validated === true" @blur="handleInputBlur" />
            </el-form-item>
            <el-form-item prop="telNo">
              <el-input v-model="formId.telNo" type="number" pattern="\d*" placeholder="휴대폰 (숫자 입력)" maxlength="11" :disabled="formId.validated === true" @blur="handleInputBlur" />
            </el-form-item>
            <el-button v-waves v-if="!isRequestAuthNumber" icon="el-icon-check" class="btn_check_big" @click="requestAuthNumber('formId')">
              인증 번호 발송
            </el-button>
            <el-button v-waves v-else icon="el-icon-check" class="btn_check_big btn_check_on" @click="requestAuthNumber('formId')">
              인증 번호 재발송
            </el-button>
          </el-form>
        </div>

        <div v-if="isRequestAuthNumber" class="getback_number">
          <div class="getback_number_tip">
            휴대폰 인증번호가 발송 되었습니다.<br/>
            인증번호를 입력해 주세요.
          </div>
          <el-form ref="formIdAuth" :model="formIdAuth" :rules="rules" class="form">
            <el-form-item prop="authNo">
              <el-input v-model="formIdAuth.authNo" class="valid_code_input" type="number" pattern="\d*" placeholder="인증번호" @blur="handleInputBlur">
                <template slot="append">{{timerText}}</template>
              </el-input>
            </el-form-item>
            <el-button v-waves class="btn_big" @click="checkAuthNumber('formIdAuth')">
              확인
            </el-button>
          </el-form>
        </div>
      </div>

      <!-- 비밀번호 찾기 -->
      <div v-if="tabType === 2" class="getback_account">
        <div class="getback_tip">
          <div>
            회원 가입 시 설정하신 정보로 회원 인증 후<br/>
            비밀번호를 변경하실 수 있습니다.
            <br/>
            <br/>
            간편 회원가입 회원이실 경우 각 SNS 화면에서<br/>
            비밀번호 찾기 하실 수 있습니다.
          </div>
        </div>

        <div class="type_getbackPwd_nav flex_center">
          <div class="flex_center" @click="handleAuthTab(1)">
            <div :class="[tabTypeAuth === 1 ? 'type_getbackPwd_nav_button_on' : '' ]" class="type_getbackPwd_nav_button">
              이메일 인증
            </div>
          </div>
          <div class="flex_center" @click="handleAuthTab(2)">
            <div :class="[tabTypeAuth === 2 ? 'type_getbackPwd_nav_button_on' : '' ]" class="type_getbackPwd_nav_button">
              휴대폰 인증
            </div>
          </div>
        </div>

        <!-- 비밀번호 - 이메일 인증 -->
        <div v-show="tabTypeAuth === 1" class="getback_form">
          <el-form ref="formEmail" :model="formEmail" :rules="rules" class="form">
            <el-form-item prop="name">
              <el-input v-model="formEmail.name" type="text" placeholder="이름" :disabled="formEmail.validated === true" @blur="handleInputBlur" />
            </el-form-item>
            <el-form-item prop="username">
              <el-input v-model="formEmail.username" type="text" placeholder="아이디 (이메일)" :disabled="formEmail.validated === true" @blur="handleInputBlur" />
            </el-form-item>
            <el-button v-if="!isRequestAuthNumber" v-waves icon="el-icon-check" class="btn_check_big" @click="requestAuthNumber('formEmail')">
              인증 메일 발송
            </el-button>
            <el-button v-else v-waves icon="el-icon-check" class="btn_check_on btn_check_big" @click="requestAuthNumber('formEmail')">
              인증 메일 재발송
            </el-button>
          </el-form>

          <div v-if="isRequestAuthNumber" class="getback_number">
            <div class="getback_number_tip">
              입력하신 메일로 인증 메일을 발송 하였습니다.<br/>
              인증번호를 입력해 주세요.
            </div>
            <el-form ref="formEmailAuth" :model="formEmailAuth" :rules="rules" class="form">
              <el-form-item prop="authNo">
                <el-input v-model="formEmailAuth.authNo" class="valid_code_input" type="number" pattern="\d*" placeholder="인증번호" @blur="handleInputBlur">
                  <template slot="append">{{timerText}}</template>
                </el-input>
              </el-form-item>
              <el-button v-waves class="btn_big" @click="checkAuthNumber('formEmailAuth')">
                확인
              </el-button>
            </el-form>
          </div>
        </div>

        <!-- 비밀번호 - 휴대폰 인증 -->
        <div v-show="tabTypeAuth === 2" class="getback_form">
          <el-form ref="formTel" :model="formTel" :rules="rules" class="form">
            <el-form-item prop="username">
              <el-input v-model="formTel.username" type="text" placeholder="아이디 (이메일)" :disabled="formTel.validated === true" @blur="handleInputBlur" />
            </el-form-item>
            <el-form-item prop="telNo">
              <el-input v-model="formTel.telNo" type="number" pattern="\d*" placeholder="휴대폰 (숫자 입력)" maxlength="11" :disabled="formTel.validated === true" @blur="handleInputBlur" />
            </el-form-item>
            <el-button v-if="!isRequestAuthNumber" v-waves icon="el-icon-check" class="btn_check_big" @click="requestAuthNumber('formTel')">
              인증 번호 발송
            </el-button>
            <el-button v-else v-waves icon="el-icon-check" class="btn_check_big btn_check_on" @click="requestAuthNumber('formTel')">
              인증 번호 재발송
            </el-button>
          </el-form>

          <div v-if="isRequestAuthNumber" class="getback_number">
            <div class="getback_number_tip">
              휴대폰 인증번호가 발송 되었습니다.<br/>
              인증번호를 입력해 주세요.
            </div>
            <el-form ref="formTelAuth" :model="formTelAuth" :rules="rules" class="form">
              <el-form-item prop="authNo">
                <el-input v-model="formTelAuth.authNo" class="valid_code_input" type="number" pattern="\d*" placeholder="인증번호" @blur="handleInputBlur">
                  <template slot="append">{{timerText}}</template>
                </el-input>
              </el-form-item>
              <el-button v-waves class="btn_big" @click="checkAuthNumber('formTelAuth')">
                확인
              </el-button>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NavTop from '@/components/navTop'
  import waves from '@/directive/waves'

  import { sendAuthNo, requestFindId, requestFindPassword } from '@/http/api/account'

  let app = null

  export default {
    name: 'Findaccount',
    directives: { waves },
    components: { NavTop },
    data () {
      return {
        nav_title: '아이디/비밀번호 찾기',
        tabType: 1,     // 1 : 아이디 찾기 , 2 : 비밀번호 찾기
        tabTypeAuth: 1, // 1 : 이메일 인증 , 2 : 휴대폰 인증
        isRequestAuthNumber: false,
        timer: null,
        timerSeconds : 0,
        timerText : '00:00',
        httpTimestamp: 0,
        formId: {
          authType: 'TI',
          name: '',
          telNo: '',
          validated: false
        },
        formIdAuth: {
          authNo: '',
          seqNo: ''
        },
        formEmail: {
          authType: 'EP',
          name: '',
          username: '',
          validated: false
        },
        formEmailAuth: {
          authNo: '',
          seqNo: ''
        },
        formTel: {
          authType: 'TP',
          username: '',
          telNo: '',
          validated: false
        },
        formTelAuth: {
          authNo: '',
          seqNo: ''
        },
        rules: {
          name: [{ required: true, message: '이름을 입력해주세요.', trigger: 'blur' }],
          telNo: [
            { required: true, message: '휴대폰 번호를 입력해주세요.', trigger: 'blur' },
            { min: 11, max: 11, message: '휴대폰 번호를 올바른 형식으로 입력해주세요.', trigger: 'blur' }
          ],
          authNo: [{ required:true , message:'인증 번호를 입력해주세요.' , trigger:'blur' }],
          username: [
            { required: true, message: '아이디를 입력해주세요.', trigger: 'blur' },
            { pattern: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, message: '아이디를 이메일 형식으로 입력해주세요.', trigger: 'blur' }
          ]
        }
      }
    },
    watch: {
      tabType (tabIndex) {
        this.isRequestAuthNumber = false
        if (this.timer != null) {
          clearInterval(this.timer)
          this.timer = null
          this.timerText = ''
        }

        if (tabIndex === 1) {
          this.formId.name = ''
          this.formId.telNo = ''
          this.formId.validated = false
          this.formIdAuth.authNo = ''
          this.formIdAuth.seqNo = ''
        } else {
          this.formEmail.name = ''
          this.formEmail.username = ''
          this.formEmail.validated = false
          this.formEmailAuth.authNo = ''
          this.formEmailAuth.seqNo = ''

          this.formTel.telNo = ''
          this.formTel.username = ''
          this.formTel.validated = false
          this.formTelAuth.authNo = ''
          this.formTelAuth.seqNo = ''
        }
      },
      tabTypeAuth (tabIndex) {
        this.isRequestAuthNumber = false
        if (this.timer != null) {
          clearInterval(this.timer)
          this.timer = null
          this.timerText = ''
        }

        if (tabIndex === 1) {
          this.$refs['formEmail'].resetFields()
          this.formEmailAuth.authNo = ''
        } else {
          this.$refs['formTel'].resetFields()
          this.formTelAuth.authNo = ''
        }
      }
    },
    created () {
      app = this
    },
    mounted () {
      if (this.$route.params.tabIndex) {
        this.tabType = this.$route.params.tabIndex
      } else {
        this.tabType = 1
      }
    },
    methods: {
      handleIdPasswordTab (index) {
        this.tabType = index
      },
      handleAuthTab (index) {
        this.tabTypeAuth = index
      },
      requestAuthNumber (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (formName === 'formId') {
              this.httpTimestamp = (new Date).getTime()
              this.$showCustomLoading()

              sendAuthNo(this.formId).then(response => {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.formIdAuth.seqNo = response.seqNo
                  app.resetTimer()
                  app.formId.validated = true
                  app.isRequestAuthNumber = true
                }, 1000 - ((new Date).getTime() - this.httpTimestamp))
              }).catch(function(error) {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.isRequestAuthNumber = false

                  app.$customAlert({
                    message: error.response.data.message
                  })
                }, 1000 - ((new Date).getTime() - app.httpTimestamp))
              })
            } else if (formName === 'formEmail') {
              this.httpTimestamp = (new Date).getTime()
              this.$showCustomLoading()

              sendAuthNo(this.formEmail).then(response => {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.formEmailAuth.seqNo = response.seqNo
                  app.resetTimer()
                  app.formEmail.validated = true
                  app.isRequestAuthNumber = true
                }, 1000 - ((new Date).getTime() - this.httpTimestamp))
              }).catch(function(error) {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.isRequestAuthNumber = false

                  app.$customAlert({
                    message: error.response.data.message
                  })
                }, 1000 - ((new Date).getTime() - app.httpTimestamp))
              })
            } else if (formName === 'formTel') {
              this.httpTimestamp = (new Date).getTime()
              this.$showCustomLoading()

              sendAuthNo(this.formTel).then(response => {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.formTelAuth.seqNo = response.seqNo
                  app.resetTimer()
                  app.formTel.validated = true
                  app.isRequestAuthNumber = true
                }, 1000 - ((new Date).getTime() - this.httpTimestamp))
              }).catch(function(error) {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.isRequestAuthNumber = false

                  app.$customAlert({
                    message: error.response.data.message
                  })
                }, 1000 - ((new Date).getTime() - app.httpTimestamp))
              })
            }
          } else {
            this.isRequestAuthNumber = false
          }
        })
      },
      secToMin () {
        var number = parseInt(this.timerSeconds)
        return `${ Math.floor(number / 60) < 10 ? '0' + Math.floor(number / 60) : Math.floor(number / 60) }:${ number % 60 < 10 ? '0' + number % 60 : number % 60 }`
      },
      checkAuthNumber (formName) {
        if (this.timer == null) {
          app.$customAlert({
            message: '인증번호가 유효하지 않습니다. 인증번호를 재발급 해주세요.'
          })
          return
        }

        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (formName === 'formIdAuth') {
              this.httpTimestamp = (new Date).getTime()
              this.$showCustomLoading()

              requestFindId(this.formIdAuth).then(response => {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.$customAlert({
                    message: '인증 완료되었습니다.',
                    success: () => {
                      app.$router.replace({ name: 'findid', params: { name: app.formId.name, usernames: response.usernames } })
                    }
                  })
                }, 1000 - ((new Date).getTime() - this.httpTimestamp))
              }).catch(function(error) {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.$customAlert({
                    message: error.response.data.message
                  })
                }, 1000 - ((new Date).getTime() - app.httpTimestamp))
              })
            } else if (formName === 'formEmailAuth') {
              this.httpTimestamp = (new Date).getTime()
              this.$showCustomLoading()

              requestFindPassword(this.formEmailAuth).then(response => {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.$customAlert({
                    message: '인증 완료되었습니다.',
                    success: () => {
                      app.$router.replace({ name: 'resetpassword', params: { username: app.formEmail.username, custNo: response.custNo } })
                    }
                  })
                }, 1000 - ((new Date).getTime() - this.httpTimestamp))
              }).catch(function(error) {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.$customAlert({
                    message: error.response.data.message
                  })
                }, 1000 - ((new Date).getTime() - app.httpTimestamp))
              })
            } else if (formName === 'formTelAuth') {
              this.httpTimestamp = (new Date).getTime()
              this.$showCustomLoading()

              requestFindPassword(this.formTelAuth).then(response => {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.$customAlert({
                    message: '인증 완료되었습니다.',
                    success: () => {
                      app.$router.replace({ name: 'resetpassword', params: { username: app.formTel.username, custNo: response.custNo } })
                    }
                  })
                }, 1000 - ((new Date).getTime() - this.httpTimestamp))
              }).catch(function(error) {
                setTimeout(function() {
                  app.$dismissCustomLoading()

                  app.$customAlert({
                    message: error.response.data.message
                  })
                }, 1000 - ((new Date).getTime() - app.httpTimestamp))
              })
            }
          } else {
            return false
          }
        })
      },
      resetTimer () {
        if (this.isRequestAuthNumber) {
          this.$customAlert({
            message: '인증번호가 재전송되었습니다.'
          })
        } else {
          this.$customAlert({
            message: '인증번호가 전송되었습니다.'
          })
        }

        if (this.timer != null) {
          clearInterval(this.timer)
        }

        this.timerSeconds = 180
        this.timerText = this.secToMin()

        this.timer = setInterval (function () {
          app.timerSeconds -= 1

          if (app.timerSeconds <= 0) {
            clearInterval(app.timer)
            app.timer = null
            app.timerText = '00:00'
          } else {
            app.timerText = app.secToMin()
          }
        }, 1000)
      },
      handleInputBlur () {
        document.body.scrollTop = document.body.scrollTop
      }
    }
  }
</script>


<style>
  .valid_code_input {
    position: relative!important;
  }
  .valid_code_input > input {
    padding-right: 1.389rem!important;
  }
  .valid_code_input .el-input-group__append{
    content: '';
    position: absolute;
    /*width: 1.278rem;*/
    /*height: 1.25rem;*/
    top: 1px;
    right: 1px;
    width: 1.333rem;
    height: 1.278rem;
    background-color: #fff;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
<style scoped lang="scss">

  .getback{
    background-color: #F8F7F4;
  }
  .section{
    padding: 1.667rem 0 0 0;
  }

  .type_nav{
    height: 1.667rem;
    background-color: #FFFFFF;
    justify-content: space-around;
  }

  .type_nav > div {
    height: 100%;
    width: 4.722rem;
  }
  .type_nav_button{
    text-align: center;
    color: #C8C8C8;
  }

  .type_nav_button_on {
    color: #F15929!important;
    padding: 0.639rem 0 0.583rem 0;
    border-bottom: 0.056rem solid #F15929;
  }

  .type_nav_button > div {
    height: 1.667rem;
  }

  .getback_pwd , .getback_account {
    padding: 1.111rem 1.028rem;
  }

  .getback_tip {
    margin-bottom: 1.111rem;
  }
  .getback_tip > div{
    color: #9F9F9F;
  }
  .getback_form{
    margin: 0;
  }

  .getback_number_tip{
    padding: 0.5rem 0 0.833rem;
    text-align: center;
  }


  .type_getbackPwd_nav{
    padding: 0 1rem 0.7rem;
  }

  .type_getbackPwd_nav > div {
    width: 50%;
  }

  .type_getbackPwd_nav > div:nth-child(1){
    border-right:  1px solid #E3E3E3;
  }

  .type_getbackPwd_nav_button{
    color:#9F9F9F;
  }

  .type_getbackPwd_nav_button_on{
    color: #F15929!important;
  }

  .btn_big {
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/Account/Findaccount.vue